module.exports = __webpack_public_path__ + "static/media/payment.211f62c0.svg";